import { Component, OnInit, Output, Input, EventEmitter, forwardRef } from '@angular/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { _HttpClient } from 'src/app/core/net/http.client';
import { ApiService } from 'src/app/core/net/apiRoute';
import {
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ResponseContext } from '../../net/response-context.interface';
import { DataSourceQuery } from '../../services/codebuild.service';
 
@Component({
  selector: 'app-select',
  templateUrl: './app-select.component.html',
  styleUrls: ['./app-select.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppSelectComponent),
      multi: true,
    }
  ]
})
export class AppSelectComponent implements OnInit {
  private _url=ApiService.loaddatasrouces;
  @Input() get url() {
    return this._url;
  }
  set url(value) {
    this._url = value;
 
  }
  @Input() query: DataSourceQuery;
   
  @Input() showSearch=false; // 使单选模式可搜索
  @Input() defaultValue; // 默认选中
  @Input() mode: any = "default"; // 模式  单选：default； 多选：multiple
  @Output() selectedValue: EventEmitter<string> = new EventEmitter(); // 输出属性
  dataSource: any = [];                                               // 数据源
  isLoading = false;


  constructor(private http: _HttpClient) {


  }
  propagateChange = (_: any) => { };
  writeValue(value: any): void {
    this.defaultValue = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {

  }
  setDisabledState?(isDisabled: boolean): void {

  }

  ngOnInit(): void {
    this.loadData();
  }

  // 选中的 nz-option 发生变化时
  modelChange(value: string): void {
    this.propagateChange(value);
    this.selectedValue.emit(value);
  }

  // 请求列表
  loadData(): void {
    //如果是数据源模式 则使用通用数据源绑定接口
    if (this._url==ApiService.loaddatasrouces&&!this.query) {
      return;
    }
 
    this.isLoading = true;
    this.http.post(this.url, this.query, false)
      .subscribe((res: ResponseContext<Array<{ Name, Id }>>) => {
        this.isLoading = false;
        if (res.Status !== 1) {
          return;
        }
        else {
          this.dataSource = res.Result;
        }
      });
  }

  
}

